/**
 * @desc 销售渠道详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.SalesChannelResponseDto>;
export function request(
  params: API.basics.salesChannel.detail.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/salesChannel/details`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
